import styles from "./Blob.module.scss";

const Blob = () => {
  return <div className={styles.blob}></div>;
};

export default Blob;
